import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { Accordion as MuiAccordion, AccordionSummary, AccordionDetails, AccordionActions, createStyles, makeStyles } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import makeClass from 'classnames';
var useStyles = makeStyles(function () {
  return createStyles({
    summary: {
      minHeight: '48px !important',
      height: '48px !important'
    },
    details: {
      padding: '0 !important'
    }
  });
});

var Accordion = function Accordion(_ref) {
  var dsOnChange = _ref.dsOnChange,
      e2e = _ref.e2e,
      elevation = _ref.elevation,
      expanded = _ref.expanded,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      header = _ref.header,
      body = _ref.body,
      footer = _ref.footer,
      getHeaderSlot = _ref.getHeaderSlot,
      getBodySlot = _ref.getBodySlot,
      getFooterSlot = _ref.getFooterSlot;
  var headerCb = React.useCallback(function (node) {
    getHeaderSlot && getHeaderSlot(node);
  }, [getHeaderSlot]);
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  var footerCb = React.useCallback(function (node) {
    getFooterSlot && getFooterSlot(node);
  }, [getFooterSlot]);
  var classes = useStyles();
  var isFullWidth = variant === 'fullWidth';
  return /*#__PURE__*/React.createElement(MuiAccordion, _extends({
    elevation: elevation,
    expanded: expanded,
    onChange: dsOnChange
  }, e2e && {
    'data-e2e': e2e
  }), /*#__PURE__*/React.createElement(AccordionSummary, _extends({
    className: makeClass(_defineProperty({}, classes.summary, isFullWidth)),
    expandIcon: /*#__PURE__*/React.createElement(ExpandMore, null)
  }, e2e && {
    IconButtonProps: {
      'data-e2e': "".concat(e2e, "-expand")
    }
  }), /*#__PURE__*/React.createElement("div", _extends({
    ref: headerCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-header")
  }), header)), /*#__PURE__*/React.createElement(AccordionDetails, _extends({
    ref: bodyCb,
    className: makeClass(_defineProperty({}, classes.details, isFullWidth))
  }, e2e && {
    'data-e2e': "".concat(e2e, "-body")
  }), body), /*#__PURE__*/React.createElement(AccordionActions, _extends({
    ref: footerCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-footer")
  }), footer));
};

export default Accordion;

try {
  Accordion.__docgenInfo = {
    description: '',
    displayName: 'Accordion',
    methods: [],
    props: {
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: false,
        type: {
          name: '(event: ChangeEvent<{}>, expanded: boolean) => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      variant: {
        defaultValue: {
          value: 'default'
        },
        description: '',
        name: 'variant',
        required: false,
        type: {
          name: 'enum',
          raw: '"fullWidth" | "default"',
          value: [{
            value: '"fullWidth"'
          }, {
            value: '"default"'
          }]
        }
      },
      header: {
        defaultValue: null,
        description: '',
        name: 'header',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      footer: {
        defaultValue: null,
        description: '',
        name: 'footer',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      getHeaderSlot: {
        defaultValue: null,
        description: '',
        name: 'getHeaderSlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      getFooterSlot: {
        defaultValue: null,
        description: '',
        name: 'getFooterSlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      expanded: {
        defaultValue: null,
        description: 'If `true`, expands the accordion, otherwise collapse it.\n' + 'Setting this prop enables control over the accordion.',
        name: 'expanded',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      elevation: {
        defaultValue: null,
        description: 'Shadow depth, corresponds to `dp` in the spec.\n' + 'It accepts values between 0 and 24 inclusive.',
        name: 'elevation',
        required: false,
        type: {
          name: 'number'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map